import { useRef, useState, useEffect } from 'react';

const TOKEN_RE = /(\{\{[\w.]+\}\})/g;

function escHtml(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function buildHighlight(text, placeholder) {
  if (!text) return `<span style="color:#bbb;pointer-events:none">${escHtml(placeholder)}</span>`;
  return text.split(TOKEN_RE).map((part) =>
    /^\{\{[\w.]+\}\}$/.test(part)
      ? `<span style="color:var(--color-brand);font-weight:600;background:var(--color-brand-softer);border-radius:3px;padding:0 3px">${escHtml(part)}</span>`
      : `<span style="color:var(--color-text-primary)">${escHtml(part).replace(/\n/g, '<br>')}</span>`
  ).join('');
}

const SHARED = {
  fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace',
  fontSize: 12,
  lineHeight: '1.7',
  padding: '5px 10px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  boxSizing: 'border-box',
};

export default function TemplateEditor({ value = '', onChange, placeholder = 'e.g.  ${{clientRate}} /{{rateType}}', disabled = false, textareaRef: externalRef }) {
  const internalRef = useRef(null);
  const taRef = externalRef ?? internalRef;
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const ta = taRef.current;
    if (!ta) return;
    ta.style.height = 'auto';
    ta.style.height = `${ta.scrollHeight}px`;
  }, [value]);

  const borderColor = disabled ? 'var(--color-border-input)' : focused ? 'var(--color-brand)' : 'var(--color-border-input)';
  const boxShadow   = focused && !disabled ? '0 0 0 2px rgba(0,83,165,0.12)' : 'none';

  return (
    <div
      style={{ position: 'relative', border: `1px solid ${borderColor}`, borderRadius: 6, background: disabled ? 'var(--color-surface-soft)' : '#fff', transition: 'border-color 0.2s, box-shadow 0.2s', boxShadow, minHeight: 34, cursor: disabled ? 'not-allowed' : 'text' }}
      onClick={() => !disabled && taRef.current?.focus()}
    >
      <div aria-hidden style={{ ...SHARED, visibility: 'hidden', minHeight: 22, pointerEvents: 'none', userSelect: 'none' }} dangerouslySetInnerHTML={{ __html: buildHighlight(value, placeholder) + '​' }} />
      <div aria-hidden style={{ ...SHARED, position: 'absolute', inset: 0, pointerEvents: 'none', userSelect: 'none', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: buildHighlight(value, placeholder) + '​' }} />
      <textarea ref={taRef} value={value} rows={1} spellCheck={false} autoCorrect="off" autoCapitalize="off" disabled={disabled}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{ ...SHARED, position: 'absolute', inset: 0, width: '100%', height: '100%', background: 'transparent', color: 'transparent', caretColor: '#333', border: 'none', outline: 'none', resize: 'none', overflow: 'hidden', cursor: disabled ? 'not-allowed' : 'text' }}
      />
    </div>
  );
}
